/**
 * @fileOverview Exports the main App component. Edit the main.component.jsx
 * file to change the content of this standalone.
 */

export * from './main.container'
